import Loader from "./Loader/Loader";
import React, { cSuspense } from "react";
import { HashRouter, Route, Routes } from "react-router-dom";

const Home = React.lazy(() => import("./Pages/Home"));

function App() {
  return (
    <div id="domainClass" className="default">
      <Loader />
      <HashRouter>
        {/* <Suspense fallback={<div>Loading...</div>}> */}
        <Routes>
          <Route path="/*" exact element={<Home />} />
        </Routes>
        {/* </Suspense> */}
      </HashRouter>
    </div>
  );
}

export default App;
